module.exports = __webpack_public_path__ + "static/media/Aromas1.4a52248e.jpeg";